import React, { useState, useEffect, useContext } from 'react';
import Auxiliary from '../../util/Auxiliary';
import axios from '../../util/Api';
import { Link } from 'react-router-dom';
import Table from '../../components/Table/Basic';
import { ParamsContext } from '../Context/ParamsContext';
import DateTime from '../../components/Formatter/DateTime';
import { useSelector } from 'react-redux';

const Request = (props) => {
  const params = useContext(ParamsContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(null);

  const { authUser } = useSelector(({ auth }) => auth);

  const columns = [
    {
      title: "Nama Proyek",
      key: 'project',
      render: record => {
        const project = record.current_project;
        // const project = record.projects.find(el => el.status.is_pending);
        return project.project.name;
      },
      filter: true,
      visible: authUser.is_superadmin,
    },
    {
      title: "Divisi Operasi",
      render: record => {
        const project = record.current_project;
        // const project = record.projects.find(el => el.status.is_pending);
        return project.division.label;
      },
    },
    {
      title: "Nama",
      key: 'name',
      render: record => (
        <>
          {record.name} ({record.gender})
        </>
      ),
      sorter: true,
      filter: true,
    },
    {
      title: "Perusahaan",
      dataIndex: "vendor",
      key: 'vendor',
      filter: true,
      render: vendor => {
        return <Link to={`/vendor/detail?id=${vendor.id}`}>{vendor.name}</Link>
      },
    },
    {
      title: "Tanggal Request",
      key: 'updated_at',
      render: record => <DateTime value={record.current_project.created_at} />,
      sorter: true,
    },
    {
      title: '',
      render: record => (
        <div className="gx-text-right">
          {record.actions.verification ? (
            <Link to={`/passport/detail?id=${record.id}`} className="ant-btn ant-btn-primary ant-btn-sm">
              Verifikasi
            </Link>
          ):null}
          <Link to={`/passport/detail?id=${record.id}`} className="ant-btn ant-btn-secondary ant-btn-sm">
            Detail
          </Link>
        </div>
      )
    }
  ];

  useEffect(() => {
    fetchPassport();
  },[params]);

  const fetchPassport = () => {
    setLoading(true);
    const url = `/passport/list`;
    axios.get(url, { params: {...params, status: 10} }).then(resp => {
      setData(resp.data.passports);
      setTotalData(resp.data.total);
      setLoading(false);
    }).catch(err => {
      console.error(err);
    });
  }

  return (
    <Auxiliary>
      <h1 className="title gx-mb-4">Menunggu Verifikasi</h1>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        total={totalData}
        showSorterTooltip
        pathname="/request"
        sticky
      />
    </Auxiliary>
  );
}

export default Request;